import(/* webpackMode: "eager" */ "/workspace-install/projects/astrolive-app/modules/Astro/TodayPanchang/index.tsx")